import * as React from "react";
import { useEffect, useState, useRef } from "react";

import { SnackbarVariantValue } from "./index";
import * as styles from "./Snackbar.css";

export interface CustomProgressBarProps {
  animationDuration: number;
  isPaused: boolean;
  onClose: () => void;
  type: SnackbarVariantValue;
  hidden: boolean;
}

export const CustomProgressBar: React.FC<CustomProgressBarProps> = ({
  animationDuration,
  isPaused,
  onClose,
  hidden,
}) => {
  const [progress, setProgress] = useState<number>(100);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const startTimeRef = useRef<number | null>(null);
  const pausedTimeRef = useRef<number>(0);
  const totalPausedTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!startTimeRef.current) {
      startTimeRef.current = Date.now();
      totalPausedTimeRef.current = 0;
    }
  }, []);

  useEffect(() => {
    if (!isPaused && progress > 0) {
      if (pausedTimeRef.current > 0) {
        totalPausedTimeRef.current += Date.now() - pausedTimeRef.current;
        pausedTimeRef.current = 0;
      }

      intervalRef.current = setInterval(() => {
        const elapsed =
          Date.now() - (startTimeRef.current || 0) - totalPausedTimeRef.current;
        const newProgress = Math.max(
          0,
          100 - (elapsed / animationDuration) * 100
        );

        setProgress(newProgress);

        if (newProgress <= 0) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
          onClose();
        }
      }, 25);
    } else if (isPaused && intervalRef.current) {
      clearInterval(intervalRef.current);
      pausedTimeRef.current = Date.now();
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, animationDuration, onClose, progress]);

  if (hidden) {
    return null;
  }
  return (
    <div className={styles.customProgressBar}>
      <div
        className={styles.customProgressBarFill}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
